import {useEffect, useState} from "react";
import customAxios from "../../../service/api/interceptors";

export type BannerType = {
    id: number;
    template_id: number;
    is_closed: number;
    text: string;
    cta_url: string;
    cta_text: string;
}

export const useBannerList = () => {
    const [bannerList, setBannerList] = useState<BannerType[]>([])
    const [loading, setLoading] = useState(false)

    const getData = async () => {
        setLoading(true)
        try {
            const { status, data } = await customAxios.get(`/banner/list`)
            if (status === 200) {
                setBannerList(data)
            }
        } catch (e) {}
        setLoading(false)
    }

    useEffect(() => {
        getData()
    }, [])

    const setBannerClose = async (id: number) => {
        setLoading(true)
        try {
            const { status, data } = await customAxios.put(`/banner/${id}/close`)
            if (status === 200) {
                setBannerList(bannerList.filter((item) => item.id !== id))
            }
        } catch (e) {}
        setLoading(false)
    }

    return {
        bannerList,
        setBannerClose,
        loading
    }
}